import { Icon, StyleProps } from "@chakra-ui/react";

export const MetaplexIcon: React.FC<StyleProps> = (props) => (
  <Icon viewBox="0 0 38 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.813 16.727a.78.78 0 0 1-.03.843l-3.77 5.428a.78.78 0 0 1-1.314-.051L.94 1.174A.78.78 0 0 1 1.614 0h6.818a.78.78 0 0 1 .67.382l9.71 16.345zm18.246 6.1A.78.78 0 0 1 36.386 24H29.61a.78.78 0 0 1-.673-.386L15.788 1.174A.78.78 0 0 1 16.461 0h6.814a.78.78 0 0 1 .674.386l13.11 22.44zm-30.739.96a.78.78 0 0 0 .671-1.177l-4.675-7.88c-.405-.683-1.45-.396-1.45.397v7.88c0 .432.349.78.78.78H6.32z"
    />
  </Icon>
);
